import {
  Directive,
  Input,
  OnChanges,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { map, Subject, takeUntil } from 'rxjs';
import { selectAuthUser } from '../store/selectors/auth.selectors';
import { Store } from '@ngrx/store';
import { Roles } from '../shared/constants/role.constants';

@Directive({
  selector: '[canEdit]',
  standalone: false,
})
export class CanEditDirective implements OnChanges, OnDestroy {
  @Input('canEdit') id: number = 0;

  private destroy$ = new Subject<void>();

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store
  ) {}

  ngOnChanges() {
    // Re-run logic whenever id changes
    this.updateView();
  }

  private updateView() {
    // Stop previous subscription
    this.destroy$.next();

    this.store
      .select(selectAuthUser)
      .pipe(
        takeUntil(this.destroy$),
        map((user) => {
          if (!user) return false;

          const allowedRoles = [Roles.Admin, Roles.Editor];
          const isAllowedRole = allowedRoles.some((role) => role === user.role);
          const isOwner = user.id === this.id;

          return isAllowedRole || isOwner;
        })
      )
      .subscribe((canEdit) => {
        this.viewContainer.clear();
        if (canEdit) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
